function checkBreakPoint() {
  w = $(window).width();
  if (w <= 1024) {
    // 各セクション個別に処理
    $('.top-collection-three-colomn').each(function() {
      const $section = $(this);
      if (!$section.hasClass('slick-initialized')) {
        // このセクションのページネーション設定を取得
        const showPagination = $section.data('show-pagination') !== false;
        
        $section.slick({
          infinite: false,
          swipe: true,
          slidesToShow: 1,
          // slidesToScroll: 1,
          centerMode: true,
          centerPadding: '0px',
          // rightPadding: '20px',
          dots: showPagination,
          arrows: false,
        });
      }
    });
  } else {
    $(".top-collection-three-colomn.slick-initialized").slick("unslick");
  }
}
// ウインドウがリサイズする度にチェック
$(window).resize(function () {
  checkBreakPoint();
});
// 初回チェック
$(document).ready(function () {
  checkBreakPoint();
});
